import { createSlice } from '@reduxjs/toolkit'

import { loadTempOrders } from '@/api/shopApi'

export const NAME = 'shop-quotes'
// @ts-ignore
export const fetchTempOrders = () => async (dispatch, getState) => {
  const isPending = getIsPending(getState())

  if (isPending) return

  dispatch(loadPending())

  try {
    const result = await loadTempOrders()

    dispatch(loadSuccess(result))
  } catch (error) {
    dispatch(loadFailure('Could not load orders'))
  }
}

const initialState = {
  isPending: false,
  isDataLoaded: false,
  error: undefined,

  textFilter: '',

  quotes: [],
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loadPending: state => {
      state.error = undefined
      state.isPending = true
    },
    loadSuccess: (state, { payload: orders }) => {
      state.isPending = false
      state.isDataLoaded = true
      state.quotes = orders
    },
    loadFailure: (state, { payload: error }) => {
      state.isPending = false
      state.isDataLoaded = true
      state.error = error
    },
    setTextFilter: (state, { payload: textFilter }) => {
      state.textFilter = textFilter
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { loadPending, loadSuccess, loadFailure, setTextFilter, reset } = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getIsPending = (state: any) => getState(state).isPending
export const getError = (state: any) => getState(state).error
export const getIsDataLoaded = (state: any) => getState(state).isDataLoaded

export const getQuotes = (state: any) => getState(state).quotes
export const getOpenQuotes = (state: any) =>
  // @ts-ignore
  getQuotes(state).filter(quote => !quote.order?.ecomOrderId)
// @ts-ignore
export const getQuote = (state, id) => getQuotes(state).find(order => order.id === id)
